module.exports = __webpack_public_path__ + "img/3.9134895c.png";